import packageJson from '../../../../package.json';

const ENVIRONMENT_NAME = 'Production';
const VERSION = packageJson.version;

export default {
    ENVIRONMENT_NAME,
    VERSION    
}